module.exports = __webpack_public_path__ + "static/media/Icons-alert.40610edd.svg";